// extracted by mini-css-extract-plugin
export default {"item":"RelatedPatientItem_item__bmvbt","item_add":"RelatedPatientItem_item_add__L5vcJ","name":"RelatedPatientItem_name__sHp36","case":"RelatedPatientItem_case__dZRDT"};